import React from "react";
import CompanyData from "./CompanyData";
import PayerData from "./PayerData";
import Staff from "./Staff";
import { whereBallsMove } from "../../helper";
import { NavLink, Route, Switch } from 'react-router-dom';

class AccountLaw extends React.Component {
    componentDidMount() {
        whereBallsMove(7)
    }

    render() {
        return(
            <div className="vertical-scrolling page seventhSection sectionAccountLaw" id="sectionAccountLaw" data-main-nav-id="accountLawNavLink">
                <div className="container content">
    
                    <div className="left-content left-content-width">
                        <h2>Личный кабинет</h2>
                        <ul className="menu-content-nav">
                            <NavLink exact to="/account-law">
                                Данные организации
                            </NavLink>
                            <NavLink to="/account-law/payer-data">
                                Данные плательщика
                            </NavLink>
                            <NavLink to="/account-law/staff">
                                Сотрудники
                            </NavLink>
                        </ul>
                    </div>
    
                    <div className="right-content native-scroll right-content-bottom right-content-width">
                        <div className="screen-outer-block-wrap native-scroll menu-content">
                            <Switch>
                                <Route exact path="/account-law" component={CompanyData} />
                                <Route path="/account-law/payer-data" component={PayerData} />
                                <Route path="/account-law/staff" component={Staff} />
                            </Switch>
                        </div>
                    </div>
                </div>
            </div>
        )
    }
}
export default AccountLaw;


// WEBPACK FOOTER //
// ./src/components/AccountLaw/index.js